import React, { useEffect, useState } from "react";
import { Layout, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CompHeader, SideMenu } from "../components";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { checkRouteName } from "../utills";
import styles from "./layoutstyle.module.css";
import { BiSolidPhoneIncoming } from "react-icons/bi";
import { MdCallEnd, MdLogout } from "react-icons/md";
import Person from "../assets/staticImages/cplImage1.png";
import { TextComponent } from "../components";
import { Modal, Spin } from "antd";
import { hideRinging, sessionExpired } from "../Store/Actions/GeneralActions";
import { VideoCallMiddleware } from "../Store/Middlewares/VideoCallMiddleware";
import { IoIosAlert } from "react-icons/io";
import { AuthMiddleware } from "../Store/Middlewares/AuthMiddleware";
import {
  changeThemeColor,
  changeThemeFont,
  getUser,
  isLogin,
} from "../Store/Actions/AuthAction";
import { ZeroEvents } from "../screens/ClientScreens/Events/Events";
import { roles } from "../config/roles";
import AgoraRTC, {
  AgoraRTCProvider,
  useRTCClient,
  useClientEvent,
} from "agora-rtc-react";
import Storage from "../utills/AsyncStorage";

const { Header, Content, Footer } = Layout;
export const ProtectedLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const agoraClient = useRTCClient(
    AgoraRTC.createClient({ codec: "vp8", mode: "rtc" }),
  ); // Initialize Agora Client
  const IsLogin = useSelector((state) => state.AuthReducer.isLogin);
  const showRinger = useSelector((state) => state.GeneralReducer.showRinging);
  const ringingOptions = useSelector(
    (state) => state.GeneralReducer.ringingOptions,
  );
  const user = useSelector((state) => state.AuthReducer.user);
  const SessionExpired = useSelector(
    (state) => state.GeneralReducer.sessionExpired,
  );

  const [collapsed, setCollapsed] = useState(false);
  const { height, width } = useWindowDimensions();
  const location = useLocation();
  const role = localStorage.getItem("role");
  console.log("roleProtected", role, IsLogin);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const accessPaths = [
    "/membership",
    "/paymentMethods",
    "/addNewCard",
    "/editCard",
  ];

  useEffect(() => {
    dispatch(AuthMiddleware.GeneralType());
  }, []);

  if (IsLogin == false) {
    // navigate('/login');
    return <Navigate to={"/"} />;
  }

  const onLogout = () => {
    dispatch(AuthMiddleware.logout()).then((data) => {
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      dispatch(changeThemeColor("#ED73AA"));
      dispatch(changeThemeFont("'Poppins', sans-serif"));
      localStorage.clear();
      navigate("/");
    });
  };
  const callEndButton = () => {
    dispatch(
      VideoCallMiddleware.declineCall({
        receiver_id: ringingOptions?.room_name
          ? false
          : ringingOptions?.caller_id,
        caller_id: ringingOptions?.room_name ? false : user?.id,
        channel: ringingOptions?.channel_name,
      }),
    ).then((data) => {
      dispatch(hideRinging());
    });
  };
  const callRecieveButton = () => {
    dispatch(VideoCallMiddleware.acceptCall())
      .then(() => {
        ringingOptions?.is_group_call
          ? navigate("/videoCall", {
              state: {
                data: ringingOptions,
                group: true,
              },
            })
          : navigate("/singleVideoCall", {
              state: {
                data: ringingOptions,
                group: false,
                incomming: true,
              },
            });
      })
      .catch();
    dispatch(hideRinging());
  };

  return (
    <AgoraRTCProvider client={agoraClient}>
      <Layout
        hasSider
        style={{
          position: "fixed",
          width: "100%",
          backgroundColor: "var(--white-color)",
        }}
      >
        <Sider
          trigger={null}
          collapsible
          width={210}
          collapsed={width > 768 ? collapsed : true}
          style={{
            backgroundColor: "var(--primary-color)",
            overflow: "auto",
            height: "97vh",
            padding: 0,
            // position: "fixed",
            overflowX: "hidden",
            // transition: "width 2s ease 2s",
            borderRadius: 10,
            marginLeft: "1%",
            marginTop: "1%",

            // marginLeft: collapsed && 15,
          }}
        >
          <SideMenu
            collapsed={collapsed}
            onBackClick={() => setCollapsed(!collapsed)}
          />
        </Sider>

        <Layout className="site-layout">
          <Header
            style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          >
            <CompHeader
              onBackClick={() => setCollapsed(!collapsed)}
              collapsed={collapsed}
              title={checkRouteName(location.pathname?.substring(1))}
            />
          </Header>
          <Content
            style={{
              // margin: "10px 4px",
              padding: "0px 20px",
              // minHeight: 650,
              background: "var(--white-color)",
            }}
          >
            {SessionExpired && (
              <div>
                <Modal
                  // title="Vertically centered modal dialog"
                  // centered
                  open={SessionExpired}
                  closable={false}
                  footer={[
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        onClick={() => onLogout()}
                        style={{
                          padding: 15,
                          backgroundColor: "#d93025",
                          borderRadius: 10,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                      >
                        <MdLogout size={15} color="#fff" />
                        <TextComponent
                          style={{
                            color: "white",
                            marginLeft: 10,
                            fontWeight: "bold",
                            fontSize: 15,
                          }}
                          text={"Logout"}
                        />
                      </div>
                      {/* <div
                      onClick={() => callRecieveButton()}
                      style={{ padding: 15, backgroundColor: '#1877ff', borderRadius: 10, cursor: 'pointer' }}>
                      <BiSolidPhoneIncoming size={15} color="#fff" />
                      <TextComponent style={{ color: 'white', marginLeft: 10, fontWeight: 'bold', fontSize: 15 }} text={"Accept"} />
                    </div> */}
                    </div>,
                  ]}
                  // onOk={() => dispatch(hideRinging())}
                  // onCancel={() => dispatch(hideRinging())}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ width: 50, height: 50, marginRight: 10 }}>
                      <IoIosAlert size={50} color="#d93025" />
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <TextComponent
                        style={{ fontWeight: "bold", fontSize: 20 }}
                        text={"Your Session Has Been Expired!"}
                      />
                    </div>
                  </div>
                </Modal>
              </div>
            )}
            {showRinger && (
              <div>
                <Modal
                  // title="Vertically centered modal dialog"
                  // centered
                  open={showRinger}
                  closable={false}
                  footer={[
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        onClick={() => callEndButton()}
                        style={{
                          padding: 15,
                          backgroundColor: "#d93025",
                          borderRadius: 10,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                      >
                        <MdCallEnd size={15} color="#fff" />
                        <TextComponent
                          style={{
                            color: "white",
                            marginLeft: 10,
                            fontWeight: "bold",
                            fontSize: 15,
                          }}
                          text={"Reject"}
                        />
                      </div>
                      <div
                        onClick={() => callRecieveButton()}
                        style={{
                          padding: 15,
                          backgroundColor: "#1877ff",
                          borderRadius: 10,
                          cursor: "pointer",
                        }}
                      >
                        <BiSolidPhoneIncoming size={15} color="#fff" />
                        <TextComponent
                          style={{
                            color: "white",
                            marginLeft: 10,
                            fontWeight: "bold",
                            fontSize: 15,
                          }}
                          text={"Accept"}
                        />
                      </div>
                    </div>,
                  ]}
                  // onOk={() => dispatch(hideRinging())}
                  // onCancel={() => dispatch(hideRinging())}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ width: 50, height: 50, marginRight: 10 }}>
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={
                          ringingOptions?.caller_image
                            ? ringingOptions?.caller_image
                            : Person
                        }
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <TextComponent
                        style={{ fontWeight: "bold", fontSize: 20 }}
                        text={"Incoming Video Call.."}
                      />
                      <TextComponent
                        style={{ fontWeight: "bold", fontSize: 20 }}
                        text={`From : ${ringingOptions?.caller_name}`}
                      />
                    </div>
                  </div>
                </Modal>
              </div>
            )}
            <Box boxClass={styles.contentBox}>
              <Outlet />
            </Box>
          </Content>
        </Layout>
      </Layout>
    </AgoraRTCProvider>
  );
};

export const ProtectedRoute = () => {
  const IsLogin = useSelector((state) => state.AuthReducer.isLogin);
  const navigate = useNavigate();
  if (IsLogin == false) {
    // navigate('/login');
    return <Navigate to={"/"} />;
  }
  return <Outlet />;
};
